import { render, staticRenderFns } from "./OtherTask.vue?vue&type=template&id=75fbed16&scoped=true"
import script from "./OtherTask.vue?vue&type=script&lang=js"
export * from "./OtherTask.vue?vue&type=script&lang=js"
import style0 from "./OtherTask.vue?vue&type=style&index=0&id=75fbed16&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75fbed16",
  null
  
)

export default component.exports